<template>
  <div>
    <encerramento-modal />
    <section role="side-modal">
      <side-modal :sides="navs" @cancela="cancela()">
        <template :slot="navs[0].identidade">
          <div class="side-body">
            <div class="row">
              <form enctype="multipart/form-data">
                <div class="row row-field">
                  <field-validation
                    css-class="col-md-6 col-sm-6"
                    label="CPF"
                    field="cpf"
                    :status="errors"
                    :custom-errors="apiErrors"
                    :show-icon="false"
                  >
                    <input
                      type="text"
                      name="cpf"
                      id="cpf"
                      class="form-control"
                      v-validate="'required|min:11'"
                      data-vv-as="CPF"
                      @change="verificaCpf($event.target.value)"
                      v-model="dependenteModal.cpf"
                      v-mask="'###.###.###-##'"
                    />
                  </field-validation>
                  <field-validation
                    css-class="col-md-6 col-sm-6"
                    label="Data de Nascimento"
                    field="dataNascimento"
                    :status="errors"
                    :custom-errors="apiErrors"
                    :show-icon="false"
                    v-if="telaEhMobile"
                  >
                    <input
                      type="date"
                      name="dataNascimento"
                      id="dataNascimento"
                      class="form-control"
                      v-model="dependenteModal.dataNascimento"
                      v-validate="'required'"
                      data-vv-as="Data de Nascimento"
                    />
                  </field-validation>
                  <field-validation
                    css-class="col-md-6 col-sm-6"
                    label="Data de Nascimento"
                    field="dataNascimento"
                    :status="errors"
                    :custom-errors="apiErrors"
                    :show-icon="false"
                    v-else
                  >
                    <date-picker
                      name="dataNascimento"
                      id="dataNascimento"
                      :config="config"
                      v-model="dependenteModal.dataNascimento"
                      v-validate="'required'"
                      data-vv-as="Data de Nascimento"
                    />
                  </field-validation>
                </div>
                <div class="row row-field">
                  <field-validation
                    css-class="col-md-12 col-sm-12"
                    label="Nome"
                    field="nome"
                    :status="errors"
                    :custom-errors="apiErrors"
                    :show-icon="false"
                  >
                    <input
                      type="text"
                      name="nome"
                      id="nome"
                      class="form-control"
                      autofocus="autofocus"
                      v-model="dependenteModal.nome"
                      v-validate="'required|max:50'"
                      data-vv-as="Nome"
                    />
                  </field-validation>
                </div>
                <div class="row row-field" v-if="validacaoMaeSeAutenticadoMasculinoEDependenteFilha()">
                  <field-validation
                    css-class="col-md-12 col-sm-12"
                    label="Nome da Mãe da filha do servidor"
                    field="mae"
                    :status="errors"
                    :custom-errors="apiErrors"
                    :show-icon="false"
                  >
                    <input
                      type="text"
                      name="mae"
                      id="mae"
                      class="form-control"
                      autofocus="autofocus"
                      v-model="dependenteModal.mae"
                      v-validate="'required|max:50'"
                      data-vv-as="Nome da Mãe"
                    />
                  </field-validation>
                </div>
                <div class="row row-field">
                  <field-validation
                    css-class="col-md-6 col-sm-6"
                    label="Vínculo familiar"
                    field="parentesco"
                    :status="errors"
                    :custom-errors="apiErrors"
                    :show-icon="false"
                  >
                    <select
                      class="form-control"
                      name="parentesco"
                      v-model="dependenteModal.tipoDependenteId"
                      v-validate="'required'"
                      data-vv-as="Parentesco"
                      @change="alteraParentesco"
                      :disabled="!podeAlterar(dependenteModal)"
                      v-if="!dependenteModal.id"
                    >
                      <option :value="null">Escolha</option>
                      <option
                        v-for="tipo in tiposDependencia"
                        :value="tipo.id"
                        :key="tipo.id"
                      >
                        {{ tipo.nome }}
                      </option>
                    </select>

                    <input
                      type="text"
                      class="form-control"
                      autofocus="autofocus"
                      v-model="dependenteModal.tipoDependenteNome"
                      :disabled="true"
                      :readonly="true"
                      v-else
                    />
                  </field-validation>
                  <field-validation
                    css-class="col-md-6 col-sm-6"
                    label="Sexo"
                    field="sexo"
                    :status="errors"
                    :custom-errors="apiErrors"
                    :show-icon="false"
                  >
                    <select
                      class="form-control"
                      name="sexo"
                      id="sexo"
                      v-model="dependenteModal.sexo"
                      v-validate="'required'"
                      data-vv-as="Sexo"
                    >
                      <option value :selected="true">Escolha</option>
                      <option
                        v-for="sexo in sexos"
                        :value="sexo.name"
                        :key="sexos.indexOf(sexo)"
                      >
                        {{ sexo.displayName | tudoMaiusculo }}
                      </option>
                    </select>
                  </field-validation>
                </div>
                <div class="row row-field">
                  <field-validation
                    css-class="col-md-6 col-sm-6"
                    label="Tem alteração de estado civil?"
                    field="alteracaoEstadoCivil"
                    :status="errors"
                    :custom-errors="apiErrors"
                    :show-icon="false"
                    v-if="dependenteEhTipoEsposo()"
                  >
                    <select
                      class="form-control"
                      id="alteracaoEstadoCivil"
                      name="alteracaoEstadoCivil"
                      v-model="dependenteModal.alteracaoEstadoCivil"
                    >
                      <option :value="false">NÃO</option>
                      <option :value="true">SIM</option>
                    </select>
                  </field-validation>
                </div>

                <div class="row row-field">
                  <p class="col-md-12 col-sm-12" v-if="validacaoMaeSeAutenticadoMasculinoEDependenteFilha()">
                    * Para dependente FILHA/ENTEADA/TUTELADA de servidor de sexo masculino o preenchimento do nome da mãe é obrigatório.
                  </p>
                </div>

                <div class="row row-field" v-if="podeAlterar(dependenteModal) && dependenteEhTipoEsposo()">
                  <p class="col-md-12 col-sm-12">
                    Caso seja inclusão de dependente que altere o estado civil do(a) servidor(a), envie quaisquer documentos
                    referentes ao novo estado civil, seja certidão de casamento ou declaração de união estável.
                    Fornecer documentos oficiais do(a) cônjuge que contenham Data de nascimento e CPF.
                  </p>
                </div>

                <div class="row row-field" v-if="!podeAlterar(dependenteModal) && dependenteEhTipoEsposo()">
                  <p class="col-md-12 col-sm-12">
                    Caso haja alteração de estado civil, envie quaisquer documentos referentes ao novo estado civil, seja certidão
                    de casamento (ou a certidão de casamento com a averbação do divórcio), declaração de união estável, certidão de óbito
                    do cônjuge. Fornecer documentos oficiais do(a) cônjuge (ou ex-cônjuge), que contenham Data de nascimento e CPF.
                  </p>
                </div>

                <div class="row row-field">
                  <div
                    class="col-xs-12 form-group"
                    style="margin-bottom: 2px"
                  >
                    <label>Anexos</label>
                  </div>
                  <div
                    class="col-xs-12 form-group"
                    style="margin-bottom: 2px"
                  >
                    <label class="btn btn-default" style="margin-bottom: 10px">
                        Anexar comprovantes
                        <input
                          type="file"
                          id="comprovantes"
                          @change="anexarArquivo"
                          ref="file"
                          multiple
                          hidden>
                    </label>
                  </div>
                </div>

                <section role="table">
                  <div class="table-responsive" style="padding: 0 15px">
                    <table class="table table-striped table-hover">
                      <thead>
                        <tr>
                          <th>Nome</th>
                          <th>&nbsp;</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(anexo, index) in dependenteModal.anexos"
                          :value="anexo"
                          :key="index"
                        >
                          <td>{{ anexo.nomeArquivo }}</td>
                          <td class="td-btns td-btns-alone">
                            <botao
                              tipo="button"
                              estilo="vazado-vermelho-sm"
                              icone="exclui-tabela"
                              @clicado="excluiAnexo(anexo)"
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </section>

              </form>
            </div>
          </div>
          <div class="side-footer">
            <botao
              tipo="button"
              estilo="cheio-cinza"
              rotulo="Cancelar"
              icone="cancela-modal"
              @clicado="cancela()"
            />
            <botao
              tipo="button"
              estilo="cheio-verde"
              rotulo="Salvar"
              icone="ok-modal"
              v-if="podeSalvar(dependenteModal)"
              @clicado="valida()"
            />
          </div>
        </template>
      </side-modal>
    </section>
    <section role="table">
      <div class="main-container container container-top">

        <div class="row">
          <field-validation
            css-class="col-md-6 col-sm-6"
            label="Selecione o registro funcional"
            field="funcionariosAutenticado"
            :status="errors"
            :custom-errors="apiErrors"
            :show-icon="false"
          >
            <select
              class="form-control"
              id="funcionarios-autenticado"
              name="funcionarios-autenticado"
              v-model="funcionarioId"
              :disabled="autenticado.funcionarios.length == 1"
            >
              <option
                v-for="funcionario in autenticado.funcionarios"
                :value="funcionario.id"
                :key="funcionario.id"
              >
                {{funcionario.tipo}} - {{ funcionario.registroFormatado }}
              </option>
            </select>
          </field-validation>
        </div>

        <div class="row row-field" v-if="!funcionarioId">
          <p class="col-md-12 col-sm-12 alert alert-info">
            Selecione o registro funcional para carregar os dependentes.
          </p>
        </div>

        <div v-else>
          <div class="row">
            <div class="col-md-12">
              <div class="card card-default">
                <div class="card-content">
                  <h4>
                    <small>
                      Atualização do Quadro Familiar, com inclusão do CPF, por exigência do e-Social.
                    </small>
                  </h4>
                  <div
                      class="alert alert-warning"
                      role="alert"
                      style="text-align: center"
                      v-if="temDependentesSemCpf"
                    >
                      <i class="fa fa-flag-o fa-lg"></i>&nbsp; Há dependentes sem o cpf cadastrado.
                  </div>
                  <div>
                    <table-loader :carregando="carregando">
                      <div
                        class="alert alert-warning"
                        role="alert"
                        style="text-align: center"
                        v-if="dependentes.length == 0"
                      >
                        <i class="fa fa-flag-o fa-lg"></i>&nbsp; Não há dependentes
                        cadastrados.
                      </div>
                      <table class="table table-striped table-hover" v-else>
                        <thead>
                          <tr>
                            <th>Nome</th>
                            <th class="hidden-xs hidden-sm">Sexo</th>
                            <th class="hidden-xs hidden-sm">Data Nascimento</th>
                            <th class="hidden-xs hidden-sm">Parentesco</th>
                            <th class="hidden-xs">CPF</th>
                            <th class="hidden-xs hidden-sm">Dependente IR</th>
                            <th>&nbsp;</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="dependente in dependentesOrdenados"
                            :key="dependentes.indexOf(dependente)">
                            <td>
                              {{ dependente.nome }}
                            </td>
                            <td class="hidden-xs hidden-sm">
                              {{ dependente.sexo }}
                            </td>
                            <td class="hidden-xs hidden-sm">
                              {{ dependente.dataNascimento | formataData }}
                            </td>
                            <td class="hidden-xs hidden-sm">
                              {{ dependente.tipoDependenteNome }}
                            </td>
                            <td class="hidden-xs">
                              {{ dependente.cpf | cpfMask }}
                            </td>
                            <td class="hidden-xs hidden-sm">
                              {{ dependente.dependenteIR | simNao}}
                            </td>
                            <td class="td-btns">
                              <botao
                                tipo="button"
                                estilo="vazado-cinza-sm"
                                icone="editar-tabela"
                                v-tooltip.right="'Editar'"
                                @clicado="edita(dependente)"
                              />
                              <botao
                                tipo="button"
                                estilo="vazado-vermelho-sm"
                                icone="exclui-tabela"
                                v-tooltip.left="'Apagar'"
                                @clicado="exclui(dependente)"
                                v-if="podeExcluir(dependente)"
                              />
                            </td>
                          </tr>
                        </tbody>
                      </table>

                      <div
                        class="col-md-12 col-xs-12 footer-controller-inner"
                        style="text-align: right"
                        v-if="!carregando">
                        <botao
                          tipo="button"
                          estilo="vazado-verde"
                          rotulo="Imprimir protocolo"
                          icone="fa-print"
                          v-if="podeImprimirProtocolo"
                          dismiss="modal"
                          @clicado="imprimeProtocolo()"
                        ></botao>

                        <botao
                          tipo="button"
                          estilo="cheio-verde-dir"
                          rotulo="Novo"
                          icone="novo-modal"
                          toggle
                          target
                          @clicado="novo()"
                        />
                      </div>

                    </table-loader>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        <div class="row row-field">
          <p>
            <strong>Estado civil do servidor: </strong> {{ pessoaAutenticada.estadoCivil }}
          </p>
        </div>

        <div class="row row-field">
          <div class="col-md-12 col-sm-12 aviso-inicial">
            <p>
              “O Recadastramento só pode ser concluído após todos os CPFs do quadro familiar serem informados.
              Exclusão do familiar (por óbito ou divórcio), bem como alteração de dependentes para fins de
              imposto de renda, só serão requeridos por e-mail: dependentes@santos.sp.gov.br. Dúvidas serão
              esclarecidas apenas pelo e-mail: secar@santos.sp.gov.br.”
            </p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Botao from '@/components/botao';
import SideModal from '@/components/side-modal';
import EncerramentoModal from './encerramento-modal';
import TableLoader from '@/components/table-loader';
import moment from 'moment';
import RecadastroDependenteService from '@/services/recadastroDependenteService';
import PessoaFisicaService from '@/services/pessoaFisicaService';
import Dependente from '@/domain/recadastroDependente';
import Anexo from '@/domain/recadastroDependente/anexo';
import DateHelper from '@/helpers/DateHelper';
import StringHelper from '@/helpers/StringHelper';
import CpfHelper from '@/helpers/CpfHelper';
import ArrayHelper from '@/helpers/ArrayHelper';
import ErrorHelper from '@/helpers/ErrorHelper';
import obtemImpressao from '@/services/obtemImpressao';
import '@/filters/filters';

export default {
  name: 'DependenteCPF',

  data() {
    return {
      apiErrors: null,
      carregando: false,
      autenticado: this.$store.state.usuarioLogado,
      pessoaAutenticada: {},
      funcionarioId: this.$store.state.funcionario.id,
      dependentes: [],
      dependenteModal: {},
      tiposDependencia:[],
      sexos: [
        {
          displayName: 'Masculino',
          name: 'M',
        },
        {
          displayName: 'Feminino',
          name: 'F',
        },
      ],
      anoEditavel: false,
      anoReferenciaAtual: 0,
      navs: [
        {
          titulo: 'Familiar',
          subtitulo: 'Dados Pessoais',
          subtDetalhe: 'Novo Familiar',
          largura: 800,
          identidade: 'dependente',
          abreProximo: false,
          aberto: false,
        },
      ],
      config: {
        format: 'L',
        useCurrent: true,
        locale: 'pt-br',
        maxDate: moment(new Date()),
        minDate: moment(new Date()).add(-150, 'years'),
      },
    };
  },

  computed: {
    dependentesOrdenados() {
      return this.dependentes.sort(
        ArrayHelper.compareValues('nome'),
      );
    },
    temDependentesSemCpf() {
      return this.dependentes.some(
        dependente => !dependente.cpf
      );
    },
    podeImprimirProtocolo() {
      return this.dependentes.length === 0 || !this.temDependentesSemCpf;
    },
    telaEhMobile() {
      return window.innerWidth <= 768;
    },
    usuarioAtual() {
      return this.$store.state.funcionario;
    },
  },

  methods: {
    abreModal(identidade) {
      this.$emit('abreModal', identidade);
    },
    fechaModal(identidade) {
      this.$emit('fechaModal', identidade);
    },
    novo() {
      this.navs[0].subtDetalhe = 'Novo Familiar';
      this.$validator.reset();
      this.dependenteModal = new Dependente();

      this.abreModal('dependente');
    },
    async imprimeProtocolo() {
      if(!this.podeImprimirProtocolo) {
        this.$root.$refs.toastr.e("Não é possível imprimir protocolo", 'Atenção');
        return;
      }

      const endpoint = `recadastro-dependentes/funcionarios/${this.funcionarioId}/protocolo`;

      try {
        await obtemImpressao(endpoint);
      } catch (error) {
        const mensagem = ErrorHelper.trataMensagem(error);
        if (mensagem === 'Desbloqueie as pop-ups para este site') {
          this.$root.$refs.toastr.w(mensagem, 'Pop-up bloqueada');
        }
        this.$root.$refs.toastr.e(mensagem, 'Atenção');
      }
    },
    verificaCpf(cpf) {
      try {
        this.validaCpf(this.dependenteModal.id, cpf);
      } catch (error) {
        this.dependenteModal.cpf = cpf;
        const mensagem = ErrorHelper.trataMensagem(error);
        this.$root.$refs.toastr.e(mensagem, 'Atenção');
      }
    },
    limpaCpfAnterior() {
      this.dependenteModal = new Dependente();
    },
    valida() {
      this.$validator.validateAll().then(success => {

        if (success) {
          if(this.validaDados()) {
            this.salva();
          }
          return;
        }
        this.$root.$refs.toastr.e(
          'Preencha ou corrija os campos em vermelho',
          'Atenção',
        );
      });
    },
    validaDados() {
      try {
        this.validaAnexos();

        let id = this.dependenteModal.id;
        let cpf = this.dependenteModal.cpf;
        this.validaCpf(id, cpf);

      } catch (error) {
        this.$root.$refs.toastr.e(ErrorHelper.trataMensagem(error), 'Atenção');

        return false;
      }

      return true;
    },
    validaAnexos() {
      if(!this.dependenteModal.anexos.length) {
        throw new Error("É obrigatório anexar comprovantes",);
      }
    },
    validaCpf(idDependente, cpf) {
      let cpfLimpo = StringHelper.limpaFormato(cpf);

      if (cpfLimpo === this.autenticado.cpf) {
        throw new Error('O declarante não pode ser o dependente. Verifique o CPF.',);
      }
      if (
        this.dependentes.some(dependencia => dependencia.cpf === cpfLimpo && dependencia.id != idDependente)
      ) {
        throw new Error('Dependente já cadastrado');
      }
      if (!CpfHelper.testaCpf(cpfLimpo)) {
        throw new Error('Número de CPF inválido');
      }
    },
    edita(dependente) {
      this.navs[0].subtDetalhe = dependente.nome;

      let dataNascimento = dependente.dataNascimento;
      if (!this.telaEhMobile) {
        dataNascimento = DateHelper.convertDateToPtbr(dataNascimento);
      }

      this.dependenteModal = JSON.parse(JSON.stringify(dependente));
      this.dependenteModal.dataNascimento = dataNascimento;

      this.abreModal('dependente');
    },
    async salva() {
      let dependenteJson = JSON.parse(JSON.stringify(this.dependenteModal));
      let anexosJson = this.dependenteModal.anexos.map(anexo => {
        return {
          id: anexo.id,
          nomeArquivo: anexo.nomeArquivo
        }
      })

      let dependente = new Dependente(
        dependenteJson.id,
        this.funcionarioId,
        dependenteJson.tipoDependenteId,
        dependenteJson.nome,
        dependenteJson.mae,
        dependenteJson.sexo,
        StringHelper.limpaFormato(dependenteJson.cpf),
        dependenteJson.dataNascimento,
        dependenteJson.alteracaoEstadoCivil,
        anexosJson);

      dependente = JSON.parse(JSON.stringify(dependente));
      dependente = StringHelper.toUpperCaseInJson(dependente);

      if (!this.telaEhMobile) {
        dependente.dataNascimento = DateHelper.convertPtbrToApiDate(dependente.dataNascimento);
      }

      const novosAnexos = this.dependenteModal.anexos.
        filter(anexo => (anexo.conteudo instanceof File) && !anexo.id).
        map(anexo => anexo.conteudo);

      if (dependente.anexos === 0) delete dependente.anexos;

      try {
        let mensagemSucesso = 'Informação salva';

        if (dependente.id) {
          await RecadastroDependenteService.atualiza(dependente.id, dependente, novosAnexos);
          await this.listaDependentesFuncionarioSelecionado();
          mensagemSucesso = 'Dependente atualizado';

        } else {
          const response = await RecadastroDependenteService.grava(dependente, novosAnexos);
          this.dependentes.push(this.criaDependenteResponse(response));
        }

        this.fechaModal('dependente');
        this.limpaModal();
        this.$root.$refs.toastr.s(mensagemSucesso, 'Sucesso');

      } catch (error) {
        const mensagem = ErrorHelper.trataMensagem(error);
        this.$root.$refs.toastr.e(mensagem, 'Atenção');
      } finally {
        this.carregando = false;
      }
    },
    async exclui(dependente) {
      const sentences = [
        {
          id: 1,
          message: 'Deseja excluir esse dependente da sua lista?',
          bold: false,
        },
      ];

      this.$root.$refs.modal.confirm(sentences, {
        yes: async () => {
          try {
            await RecadastroDependenteService.exclui(dependente.id);
            this.dependentes.splice(this.dependentes.indexOf(dependente), 1);
            this.$root.$refs.toastr.s('Dependente excluído', 'Sucesso');
          } catch (error) {
            this.$root.$refs.toastr.e(ErrorHelper.trataMensagem(error), 'Atenção');
          }
        },
        title: 'Deletando Dependente',
      });
    },

    cancela() {
      this.limpaModal();
      this.fechaModal('dependente');
    },
    limpaModal() {
      setTimeout(() => this.dependenteModal = new Dependente(), 600);
    },
    anexarArquivo() {
      let arquivos = [...this.$refs.file.files];

      arquivos.forEach(arquivo => {
        let totalArquivos = this.dependenteModal.anexos.length;

        if (totalArquivos >= 6) {
          this.$root.$refs.toastr.e(
            'Não é possível anexar mais que 6 arquivos por dependente',
            'Atenção',
          );
          return;
        }

        let dataAtual = DateHelper.convertPtbrToApiDate(moment(new Date()).format('YYYY-MM-DD'));
        this.dependenteModal.anexos.push(new Anexo(null, arquivo.name, dataAtual, arquivo));

      });

      document.getElementById("comprovantes").value = '';

    },

    excluiAnexo(anexo) {
      this.dependenteModal.anexos.splice(this.dependenteModal.anexos.indexOf(anexo), 1);
    },

    podeAlterar(dependente) {
      return dependente.id == null;
    },

    podeExcluir(dependente) {
      return dependente.tipoAlteracao == 'I' && dependente.statusValidacao == 'P';
    },

    podeSalvar(dependente) {
      return !dependente.statusValidacao || dependente.statusValidacao == 'C' || dependente.statusValidacao == 'P';
    },

    dependenteEhTipoEsposo() {
      if(!this.dependenteModal || !this.dependenteModal.tipoDependenteId) return false;

      const tipoDependencia = this.tiposDependencia.find(tipo => this.dependenteModal.tipoDependenteId == tipo.id);
      return ['ESPOSO', 'ESPOSA', 'COMPANHEIRA', 'COMPANHEIRO'].includes(tipoDependencia.nome);
    },

    validacaoMaeSeAutenticadoMasculinoEDependenteFilha() {
      if(!this.dependenteModal || !this.dependenteModal.tipoDependenteId) return '';

      const tipoDependencia = this.tiposDependencia.find(tipo => this.dependenteModal.tipoDependenteId == tipo.id);

      if(!tipoDependencia) return;

      const autenticadoEhMasculino = ("M" === this.pessoaAutenticada.sexo);

      const dependenteEhFilha =
        tipoDependencia.nome.includes("FILHA")
        || tipoDependencia.nome.includes("ENTEADA")
        || tipoDependencia.nome.includes("TUTELADA");

      if(autenticadoEhMasculino && dependenteEhFilha) {
        return 'required|max:50';
      }

      return '';
    },

    alteraParentesco() {
      if(!this.dependenteModal || this.dependenteModal.id) return;

      this.dependenteModal.mae = null;
      this.dependenteModal.alteracaoEstadoCivil = false;
    },

    abreEncerramentoModal() {
      const dataAtual = moment(new Date());
      const dataInicioAviso = moment('06/08/2022', 'DD/MM/YYYY');

      if(dataAtual.isSameOrAfter(dataInicioAviso)) {
        jQuery('#encerramentoModal').modal('show');
      }

    },

    // Requisição
    async listaDependentesFuncionarioSelecionado() {
      this.executaRequisicao(async () => {
        this.dependentes = [];

        if(this.funcionarioId) {
          const dependentesFuncionario = await RecadastroDependenteService.lista(this.funcionarioId);
          dependentesFuncionario.content.map(response => this.dependentes.push(this.criaDependenteResponse(response)));
        }

      });
    },
    criaDependenteResponse(response) {
      let dependente = {};

      dependente.id = response.id;
      dependente.nome = (response.nome) ? response.nome : response.nomeCarga;
      dependente.mae = (response.mae) ? response.mae : response.maeCarga;
      dependente.cpf = (response.cpf) ? response.cpf : response.cpfCarga;
      dependente.sexo = (response.sexo) ? response.sexo : response.sexoCarga;
      dependente.dataNascimento = (response.dataNascimento) ? response.dataNascimento : response.dataNascimentoCarga;
      dependente.tipoDependenteId = response.tipoDependenteId;
      dependente.tipoDependenteNome = response.tipoDependenteNome;
      dependente.dependenteIR = response.dependenteIR;
      dependente.responsavelId = response.responsavelId;
      dependente.alteracaoEstadoCivil = response.alteracaoEstadoCivil;
      dependente.anexos = response.anexos;
      dependente.tipoAlteracao = response.tipoAlteracao;
      dependente.statusValidacao = response.statusValidacao;

      dependente.nomeCarga = response.nomeCarga;
      dependente.maeCarga = response.maeCarga;
      dependente.cpfCarga = response.cpfCarga;
      dependente.sexoCarga = response.sexoCarga;
      dependente.dataNascimentoCarga = response.dataNascimentoCarga;

      return dependente;
    },
    async listaTiposDependencia() {
      this.executaRequisicao(async () => {
        this.tiposDependencia = await RecadastroDependenteService.listaTiposDependencia()
      });
    },

    async buscaPessoaAutenticada() {
      this.pessoaAutenticada = await PessoaFisicaService.obtemAutenticada();
    },

    executaRequisicao(requisicao) {
      this.carregando = true;
      try {
        requisicao();
      } catch (error) {
        const mensagem = ErrorHelper.trataMensagem(error);
        this.$root.$refs.toastr.e(mensagem, 'Atenção');
      } finally {
        this.carregando = false;
      }
    },
  },

  created() {
    this.buscaPessoaAutenticada();
    this.listaTiposDependencia();
    this.listaDependentesFuncionarioSelecionado();
    this.anoReferenciaAtual = moment(new Date()).year();
  },

  mounted() {
    window.scrollTo(0, 0);
    this.abreEncerramentoModal();
  },

  watch: {
    usuarioAtual(novo, anterior) {
      this.funcionarioId = novo.id;
    },
    funcionarioId(novo, anterior) {
      let funcionario = this.autenticado.funcionarios.find(func => this.funcionarioId == func.id);
      this.$store.commit('setFuncionario', funcionario);

      this.listaDependentesFuncionarioSelecionado();
    },

  },

  components: {
    Botao,
    SideModal,
    EncerramentoModal,
    TableLoader,
  },
};
</script>

<style scoped>
  [hidden] {
    display: none !important;
  }
  .aviso-inicial {
    font-size: 1.1em;
    color: #FF3C3C;
    text-align: justify;
    padding-left: 0
  }
</style>



// WEBPACK FOOTER //
// index.vue?77a97405